import React, { useContext } from 'react';
import { FormProps } from '../AccountCreationForm';
import { FieldProps, Form, Field as FormikField } from 'formik';
import { FormColumn, FormRow } from '@xo-union/tk-component-form-grid';
import { H3, Body2, Caption } from '@xo-union/tk-ui-typography';
import { Field, Checkbox, DateDropdown } from '../../../../libs/gs-component-form';
import Continue from '../Continue';
import Alert from '../Alert';
import LoadingOverlay from '../LoadingOverlay';
import styles from './index.scss';
import GoogleLocationTypeahead from '../GoogleGeolocationTypeahead';
import { OnboardingContext } from '../../../OnboardingContext';

const BasicInfoFields: React.FC<FormProps> = ({ erroring, errorMessage, onAlertTimeout, values, loading }) => {
  const continueText = 'Continue';
  const { loading: isRequestLoading, weddingLocation, onboardingType, isLoggedIn } = useContext(OnboardingContext);
  const isLoading = loading || isRequestLoading;

  return (
    <div className={styles.wrapper}>
      <Alert erroring={erroring} errorMessage={errorMessage} onTimeout={onAlertTimeout} />
      {!isLoggedIn && (
        <Body2 className={styles.steps}>
          Step 1 of 2
          <br />
        </Body2>
      )}
      <H3 className={styles.header}>Looks great! Let's add your info</H3>
      <Form>
        <LoadingOverlay loading={isLoading} />
        <FormRow>
          <FormColumn xs="6" sm="6" lg>
            <FormikField name="firstName" label="First name" component={Field} data-testid="firstName" />
          </FormColumn>
          <FormColumn xs="6" sm="6" lg>
            <FormikField name="lastName" label="Last name" component={Field} data-testid="lastName" />
          </FormColumn>
        </FormRow>

        <FormRow>
          <FormColumn xs="6" sm="6" lg>
            <FormikField
              name="fianceFirstName"
              label="Partner's first name"
              component={Field}
              data-testid="fianceFirstName"
            />
          </FormColumn>
          <FormColumn xs="6" sm="6" lg>
            <FormikField
              name="fianceLastName"
              label="Partner's last name"
              component={Field}
              data-testid="fianceLastName"
            />
          </FormColumn>
        </FormRow>
        <FormRow>
          <FormColumn xs="6" sm="6" lg style={{ zIndex: 3 }}>
            <FormikField
              name="weddingDate"
              label="Wedding Date"
              component={DateDropdown}
              disabled={values?.weddingDateTBA}
              data-testid="wedding-date-field"
              readOnly={false}
            />
          </FormColumn>
          <FormColumn xs="6" sm="6" lg style={{ paddingTop: '12px' }}>
            <FormikField
              data-testid="wedding-date-tba-checkbox"
              name="weddingDateTBA"
              component={Checkbox}
              disabledText="We're still deciding"
              enabledText="We're still deciding"
            />
          </FormColumn>
        </FormRow>
        {!isLoading && (
          <FormRow>
            <FormColumn xs="12">
              <FormikField name="weddingLocation">
                {({ field: { name, value }, form: { setFieldValue } }: FieldProps) => (
                  <GoogleLocationTypeahead
                    name={name}
                    label="Wedding city (optional)"
                    defaultInputValue={weddingLocation || value}
                    onInputChange={(val: string) => {
                      !val.length && setFieldValue(name, '');
                    }}
                    onChange={(val: string) => setFieldValue(name, val)}
                  />
                )}
              </FormikField>
            </FormColumn>
          </FormRow>
        )}
        {onboardingType === 'AI' && (
          <FormRow>
            <FormColumn xs="12" sm="12" lg style={{ paddingTop: '12px' }}>
              <FormikField
                data-testid="wws-searchable-checkbox"
                name="searchable"
                checked={values.searchable}
                component={Checkbox}
                disabledText="Appear in search engines after publishing"
                enabledText="Appear in search engines after publishing"
              />
              <Caption className={styles.subhead} style={{ width: '100%', marginTop: '-12px' }}>
                This lets guests find your published site without a link
              </Caption>
            </FormColumn>
          </FormRow>
        )}
        <Continue buttonText={continueText} variant={true} />
      </Form>
      <Body2 className={styles.subhead} style={{ marginTop: '24px', width: '100%', textAlign: 'center' }}>
        You can easily edit this info later.
      </Body2>
    </div>
  );
};

export default BasicInfoFields;
